// Must stay first: redirects /demo before the stylesheet, React or the app load.
import { isDemoPath } from "./utils/demoRedirect";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { applyDocumentMetadata } from "./utils/metadata";
if (!isDemoPath()) {
  applyDocumentMetadata();
  const rootEl = document.getElementById("root");
  if (rootEl) {
    ReactDOM.createRoot(rootEl).render(<App data-id="element-427" data-mp="2aacmx2zjlwc1" />);
  }
}